import ColumnFactory from '@/Factories/ColumnFactory';
import ComponentManager from '@/Management/ComponentManager';
import * as StringFormatter from '@/Utility/StringFormatter';
import Utilities from '@/Utility/Utilities';

export default class TextColumnFactory extends ColumnFactory {

    public static isPlainText = true;
    public static isJQueryElement = false;
    private static xamlPattern = /\<[^\>]*?\sText=""([^\""]*?)"".*?\>|\<Run[^>]*?\>([^\<\>]*?)\<\/Run\>|\<Paragraph[^>]*?\>/g;

    constructor(params: any) {
        super(params);
    }

    public getValue(): string {
        let textValue = Utilities.isNullOrUndefined(this.raw) ? '-' : this.raw.toString();
        let unxamled = this.removeXAML(textValue);
        let unhtmled = this.removeHTML(unxamled);
        let encoded = this.encodeHTML(unhtmled);
        let cleaned = this.stringCleaner(encoded, 150);

        return cleaned;
    }

    private removeHTML(html: string): string {
        let text = null;
        // Zeilenumbrüche durch eine Leerzeile ersetzen
        html = html.replace(/\<br\>+/g, '\n');

        // HTML entfernen
        try {
            let doc = new DOMParser().parseFromString(html, 'text/html');
            text = doc.body?.textContent;
        } catch (error) {
            return html;
        }

        return text;
    }

    private removeXAML(xaml: string): string {
        if (!this.isXAML(xaml)) {
            return xaml;
        }

        try {
            let doc = $.parseXML(xaml);
            return this.extractXAMLText($(doc.documentElement), true);
        }
        catch (e) {
            try {
                return this.extractXAMLTextByRegex(xaml);
            }
            catch (f) {
                return xaml;
            }
        }
    }

    private extractXAMLText(node: JQuery<HTMLElement>, isFirst: boolean): string {
        let ret = "";
        node.children().each((i: number, element: HTMLElement) => {
            let item = $(element);

            let children = item.children();
            let hasChildren = children.length > 0;

            let text = item.attr("Text");
            if (text != null) {
                ret += text;
            }
            else if (item.is("Run") && !hasChildren) {
                ret += item.text();
            }
            else if (item.is("Paragraph") && hasChildren && !isFirst) {
                //Zeilenumbr�che sollen erhalten bleiben
                ret += '\n';
            }

            isFirst = false;

            if (hasChildren) {
                ret += this.extractXAMLText(item, false);
            }
        });

        return ret;
    }

    private extractXAMLTextByRegex(xaml: string): string {
        let sb = "";

        TextColumnFactory.xamlPattern.exec(""); // reset

        let match;
        while ((match = TextColumnFactory.xamlPattern.exec(xaml)) !== null) {
            let val = match[0];
            if (val.startsWith("<P")) {
                if (sb.length > 0) {
                    sb += '\n';
                }
            }
            else if (val.startsWith("<R")) {
                sb += match[2];
            }
            else {
                sb += match[1];
            }
        }

        return sb;
    }

    private isXAML(xaml: string): boolean {
        return !String.isNullOrEmpty(xaml) && xaml.length > 19 && xaml.substring(0, 8) == '<Section';
    }

    private stringCleaner(str: string, maxLength: number): string {
        if (str == null) {
            return str;
        }

        str = str.toString();

        if (str.indexOf("\n") > -1 || str.indexOf("\r") > -1) {
            str = str.replace(/\\n\\r/g, ' $#% ');
            str = str.replace(/\\r\\n/g, ' $#% ');
            str = str.replace(/\\n/g, ' $#% ');
            str = str.replace(/\\r/g, ' $#% ');

            while (str.indexOf('$#%  $#%') > -1) {
                str = str.replace(/\$#%[\s]+\$#%/g, '$#%');
            }

            str = str.trim();
            str = str.replace(/\$#%/g, '-');
        }

        if (maxLength > 0 && maxLength < str.length - 1) {
            str = str.substring(0, maxLength - 3);
            str = str + '...';
        }

        return str;
    }

    private encodeHTML(html: string): string {
        return StringFormatter.escapeHtml(html, true);
    }
}

ComponentManager.setFactory('TextColumn', TextColumnFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');